module.exports = __webpack_public_path__ + "static/edinme-mail-e5922b42e3f2fd97e1372a6800521fc8.jpg";